import { render } from "./ModalErpDetail.vue?vue&type=template&id=1d83930a&scoped=true"
import script from "./ModalErpDetail.vue?vue&type=script&lang=js"
export * from "./ModalErpDetail.vue?vue&type=script&lang=js"

import "./ModalErpDetail.vue?vue&type=style&index=0&id=1d83930a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d83930a"]])

export default __exports__